import React from 'react';
import PropTypes from 'prop-types';
import { publish } from '@wh/message-bus';
import { DrawerItem, IconAsset } from '@sitebase/web-shell-kit';
import { FEEDBACK_OPEN_TOPIC } from '../../topics';
import { FEEDBACK_RENDERER_TYPE } from '../../rendererTypes';

const renderFeedback = ({ data }) => {
  const { id, label, icon } = data;
  return (
    <DrawerItem
      data-test-id={`${FEEDBACK_RENDERER_TYPE}.item_${id}`}
      key="@sportsbook_menu_link_feedback"
      icon={icon ? <IconAsset name={icon} /> : undefined}
      onClick={() => {
        publish({ topic: FEEDBACK_OPEN_TOPIC });
      }}
    >
      <span data-test-id={`${FEEDBACK_RENDERER_TYPE}.label_${id}`}>{label}</span>
    </DrawerItem>
  );
};

renderFeedback.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }),
};

const buildFeedbackRenderer = () => ({
  type: FEEDBACK_RENDERER_TYPE,
  render: renderFeedback,
  schema: {},
});

const FeedbackRenderer = buildFeedbackRenderer();

export default FeedbackRenderer;
